module.exports = "<da-map-legend title=\"Legend\">\n  <da-map-legend-item>\n    <div da-map-legend-item-key>\n      <market-marker></market-marker>\n    </div>\n    <div da-map-legend-item-title>Market</div>\n  </da-map-legend-item>\n</da-map-legend>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/market/components/map/market-legend.component.html
// module id = ./src/app/features/market/components/map/market-legend.component.html
// module chunks = main